import React, { useState } from "react";
import { Box, Button, Modal, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import SnackbarAlert from "../snackbar-alert/SnackbarAlert";
import "../../components/style.scss";
import "./SignaturePopup.scss";
import { setESignature, setOffline } from "../../pages/customer-form/customer-form.slice";
import Loader from "../../components/Loader";

function SignaturePopup({ closePopup, handleESignature, handleOffline }) {
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(true);
  const [selectedMethod, setSelectedMethod] = useState("");
  const { isLoading } = useSelector((state) => state?.customerForm);
  const [snackbarConfig, setSnackBarconfig] = useState({
    open: false,
    message: "",
    severity: "",
  });

  const handleSnackbarClose = () => {
    setSnackBarconfig({
      open: false,
      message: "",
      severity: "",
    });
  };

  const handleSignatureSubmit = () => {
    if (selectedMethod === "eSignature") {
      dispatch(setESignature(true));
      dispatch(setOffline(false)); // Reset offline
      handleESignature();
    } else if (selectedMethod === "offline") {
      dispatch(setOffline(true));
      dispatch(setESignature(false)); // Reset eSignature
      handleOffline();
    } else {
      setSnackBarconfig({
        open: true,
        message: "Please select a signature method",
        severity: "warning",
      });
    }
  };

  return (
    <>
      {isLoading && <Loader isLoading={isLoading} />}
    <div>
      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(!openModal);
        }}
        hideBackdrop={true}
        disableEscapeKeyDown={true}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        className="UploadDetailsModalSignature"
      >
        <Box
          className="modalContainerSignature"
          sx={{
            width: { xs: "90%", sm: "80%", md: "70%", lg: "50%" },
            maxHeight: "80vh",
            overflowY: "auto",
            bgcolor: "background.paper",
            boxShadow: 24,
            borderRadius: 1,
            p: 4,
          }}
        >
          <Box sx={{ border: "0" }}>
            <div className="closeModal" onClick={() => closePopup(false)}>
              <HighlightOffIcon />
            </div>
            <Typography
              className="modalTitleSignature"
              id="modal-modal-title"
              variant="h6"
              component="h2"
            >
              Select Your Signature Method
            </Typography>
            
              <Typography
                className="titleSignature"
                sx={{ textAlign: "center" }}
              >
                Kindly select your preferred signature method. The chosen option will apply to all applicants. 
              </Typography>
          </Box>

          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center'}}>

          <FormControl>
            <RadioGroup
            value={selectedMethod}
            onChange={(e) => setSelectedMethod(e.target.value)}
            >
            <Box 
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 2,
                marginBottom: '17px',
            }}>
                <FormControlLabel value="eSignature" control={<Radio />} label="E-Signature" />
                <FormControlLabel value="offline" control={<Radio />} label="Offline" />
            </Box>
            </RadioGroup>
          </FormControl>
          </Box>

            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                gap: 5,
            }}>
                <Button
                  sx={{
                    width: "157px",
                    height: "48px",
                    borderRadius: "8px",
                    background: "#1A407D",
                    color: "#fff",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    textTransform: "capitalize",
                    "&:hover": {
                      backgroundColor: "#092552",
                    },
                  }}
                  onClick={handleSignatureSubmit}
                >
                  Save
                </Button>
                <Button
                  sx={{
                    width: "157px",
                    height: "48px",
                    borderRadius: "8px",
                    border: "1px solid #1A407D",
                    color: "#1A407D",
                    fontSize: "16px",
                    fontWeight: "600",
                    lineHeight: "24px",
                    textTransform: "capitalize",
                    "&:hover": {
                      backgroundColor: "#E3EAF5",
                    },
                  }}
                  onClick={() => closePopup(false)}
                >
                  Cancel
                </Button>
            </Box>
        </Box>
      </Modal>
      <SnackbarAlert
        open={snackbarConfig.open}
        message={snackbarConfig.message}
        severity={snackbarConfig.severity}
        onClose={handleSnackbarClose}
      />
    </div>
    </>
  );
}

export default SignaturePopup;